import { colors, font, fontFamilies } from '@toilet-paper-games/ui';
import { URLs } from '../utils/url';

export const BlogLink = (props: { className?: string }) => {
  return (
    // Using an a tag because <Link> throws an error in certain contexts
    <a
      css={[font(fontFamilies.secondary, 'min(5vw,2em)', 1, colors.primary)]}
      href={URLs.blog}
      target="_blank"
      {...props}
    >
      Visit the tp.games blog!
    </a>
  );
};
